module.exports = __webpack_public_path__ + "img/icon-invest.f216f70b.svg";